export const GlobalConstants = {
    FormInputTypes: {
        INPUT: "input",
        CHECKBOX: "checkbox",
        PLACES: "places",
        SEARCH_FILTER: "search filter",
        CALENDAR: "calendar",
        TEXTAREA: "textarea",
        FILE: "file",
        RADIO: "radio",
        DROPDOWN: "dropdown",
        YEAR_MONTH: "year-month"
    },
    InputTypes: {
        FLOAT: "float",
        INT: "int",
        STRING: "string",
        ZIP: "zip",
        PROPERTIES: "properties",
        WL_BROKER_FEE: "wlBrokerFee",
        CREDIT: "credit",
        PERCENT: "percent",
        PERCENTAGE: "percentage",
        DOLLAR: "dollar",
        MASKED: "masked",
        ORGANIZATION: "organization",
        LOAN_TERM: "loan term",
        EIN: "ein",
        SUBDOMAIN: "subdomain",
        SOCIAL_SECURITY: "socialSecurity",
        NUMBER: "number",
        YEAR_MONTH: "year-month"
    },
    ErrorLevels: {
        ERROR: "Error",
        WARNING: "Warning",
        INFO: "Info",
        CRITICAL: "Critical"
    },
    Payeezy: {
        SUCCESS_ID: "d3a8a068-e043-4614-8d1b-377996a6fbe9",
        FAILED_ID: "8af59a46-ed3c-4e03-b256-50e71aa02b6d"
    },
    Portals: {
        BROKER: "Broker",
        BORROWER: "Borrower",
        LOAN_OFFICER: "Loan Officer",
        LMS: "LMS"
    },
    Channels: {
      WHOLESALE: "2d35edc1-5d0b-46e8-a932-acc300e082b1",
      RETAIL: "19203bb3-5dc2-48f6-9f66-acc300e09296",
      DIRECT_SALES: "541e0e59-db12-4bab-8f7b-acc300e07503"
    },
    Links: {
        FAQ: "https://builders-capital.com/builders-capital-portal-faq",
        PAYOFF_REQUEST: "https://builders-capital.com/payoff-request",
    },
    FetchApiErrors: {
        MOCK: "Error getting the mock data",
        API: "Error getting the api data",
        GENERIC: "Error getting the data"
    },
    BCStoreReducerCases: {
        SET_GLOBAL_FILTERS: "SET_GLOBAL_FILTERS",
        SET_INITIAL_GLOBAL_FILTERS: "SET_INITIAL_GLOBAL_FILTERS",
        RESET_GLOBAL_FILTERS: "RESET_GLOBAL_FILTERS",
        SET_API_CACHE: "SET_API_CACHE",
        SET_API_MULTI_CACHE: "SET_API_MULTI_CACHE",
        SET_API_CACHE_GRID_COUNT: "SET_API_CACHE_GRID_COUNT",
        CLEAR_API_CACHE: "CLEAR_API_CACHE",
        SET_USER: "SET_USER",
        TOGGLE_FILTER: "TOGGLE_FILTER",
        SET_SEARCH_VALUE: "SET_SEARCH_VALUE",
        OPEN_FILTER: "OPEN_FILTER",
        CLOSE_FILTER: "CLOSE_FILTER",
        TOGGLE_FILTER_SETTINGS: "TOGGLE_FILTER_SETTINGS",
        TOGGLE_FILTERING_DISABLED: "TOGGLE_FILTERING_DISABLED",
        OPEN_FILTER_SETTINGS: "OPEN_FILTER_SETTINGS",
        CLOSE_FILTER_SETTINGS: "CLOSE_FILTER_SETTINGS",
        SET_ITEMS: "SET_ITEMS",
        SET_INFO: "SET_INFO",
        CLEAR_INFO: "CLEAR_INFO",
        SET_STATE: "SET_STATE",
        SET_IFRAME_OPTIONS: "SET_IFRAME_OPTIONS"
    },
    LmsTableReducerCases: {
        SET_FILTER_SUBMIT_MODAL: "SET_FILTER_SUBMIT_MODAL",
        SET_CURRENT_VIEW_VALUE: "SET_CURRENT_VIEW_VALUE",
        SET_CURRENT_VIEW_SETTINGS: "SET_CURRENT_VIEW_SETTINGS",
        SET_ALL_VIEW_OPTIONS: "SET_ALL_VIEW_OPTIONS",
        SET_COLUMNS: "SET_COLUMNS",
        SET_COLUMNS_LIST: "SET_COLUMNS_LIST",
        SET_CURRENT_VIEW_COLUMNS: "SET_CURRENT_VIEW_COLUMNS",
        SET_CURRENT_VIEW_FILTERS: "SET_CURRENT_VIEW_FILTERS",
        SET_CURRENT_VIEW_FIELD_TYPES: "SET_CURRENT_VIEW_FIELD_TYPES",
        SET_CURRENT_VIEW_SORT: "SET_CURRENT_VIEW_SORT",
        SET_CURRENT_VIEW_GROUPS: "SET_CURRENT_VIEW_GROUPS",
        SET_SEARCH_VALUE: "SET_SEARCH_VALUE",
        SET_PAGINATION: "SET_PAGINATION",
        SET_ACTIVE_PAGE: "SET_ACTIVE_PAGE",
        RESET_ACTIVE_PAGE: "RESET_ACTIVE_PAGE",
        SET_FIRST_ENTRY_INDEX: "SET_FIRST_ENTRY_INDEX",
        SET_LAST_ENTRY_INDEX: "SET_LAST_ENTRY_INDEX",
        DELETE_CURRENT_VIEW_OPTION: "DELETE_CURRENT_VIEW_OPTION",
        TOGGLE_FILTERING_DISABLED: "TOGGLE_FILTERING_DISABLED",
        SET_ITEMS: "SET_ITEMS",
        SET_STATE: "SET_STATE"
    },
    ScreenSizes: {
        TABLET_SIZE: 1024,
        MOBILE_SIZE: 768
    },
    Icons : {
        ADD: "add circle",
        EDIT: "edit",
        DELETE: "trash alternate",
        COPY: "copy outline",
        EXPORT: "dropdown",
        CANCEL: "ban",
        CLOSE: "close",
        SAVE: "save outline",
        CARET_UP: "caret up",
        EXCEL_OUTLINE: "file excel outline",
        PDF_OUTLINE: "file pdf outline",
        FILE_OUTLINE: "file alternate outline",
        CHEVRON_DOWN: "chevron down",
        CHEVRON_UP: "chevron up",
        CHEVRON_LEFT: "chevron left",
        CHEVRON_RIGHT: "chevron right",
        ARCHIVE: "archive",
        TOGGLE_ON: "toggle on",
        TOGGLE_OFF: "toggle off",
        DOWNLOAD: "download",
        EXTERNAL_LINK: "external alternate",
        BAN: "ban",
        NEXT: "caret right",
        PREV: "caret left",
        INFO: "info",
        ANGLE_DOUBLE_LEFT: "angle double left",
        ANGLE_DOUBLE_RIGHT: "angle double right",
        ANGLE_LEFT: "angle left",
        ANGLE_RIGHT: "angle right",
        QUESTION: "question circle outline",
        SETTING: "setting",
        SEARCH: "search"
    },
    StaticMessage: {
        animation: "fly down",
        duration: 750
    },
    DefaultValues : {
        tablePagination : 15,
        messageAnimation : "fade",
        messageTransitionDuration: 750,
        messageStyles: "full-width",
        messageHeaderText: "Operation failed",
        messageHeaderSuccessText: "Success!",
        messageText: "It looks like something went wrong.",
        messageEmptyTableInfoText: "No records has been found.",
        messageDefaultColor: "red",
        messageInfoColor: "green",
        messageAutoCloseIn: 5000,
        messageFormSubmitSuccess: "Form has been saved successfully.",
        messageTableSubmitSuccess: "The operation was completed successfully.",
        GUID_LENGTH: 36,
        DROPDOWN_LIMIT: 500,
        CLEAR_INFO_TIME: 2000,
        defaultSliceKanban: 5,
        minTableColumnWidth: 50,
        SIDEBAR_DELAY_TIME: 400
    },
    FieldPositionStyles: {
        "left-center": "lms-form-generator-field-left",
        "center": "lms-form-generator-field-center",
        "right-center": "lms-form-generator-field-right",
        "top-left": "lms-form-generator-field-top-left",
        "top-center": "lms-form-generator-field-top-center",
        "top-right": "lms-form-generator-field-top-right",
    },
    LMSStoreReducerCases : {
        SET_FILTER_TABS: "SET_FILTER_TABS",
        ADD_FILTER_TAB: "ADD_FILTER_TAB",
        SET_ACTIVE_TAB: "SET_ACTIVE_TAB",
        CLEAR_ACTIVE_TAB: "CLEAR_ACTIVE_TAB",
        SET_ACTIVE_PATH: "SET_ACTIVE_PATH",
        REMOVE_TAB: "REMOVE_TAB",
        SET_API_CACHE: "SET_API_CACHE",
        SET_SELECTED_DATA: "SET_SELECTED_DATA",
        SET_ACTIVE_PAGE: "SET_ACTIVE_PAGE",
        SET_ACTIVE_PAGE_DATA: "SET_ACTIVE_PAGE_DATA",
        SET_ACTIVE_PAGE_SORTED_DATA: "SET_ACTIVE_PAGE_SORTED_DATA",
        SET_ACTIVE_PAGE_CHECKED_ITEMS: "SET_ACTIVE_PAGE_CHECKED_ITEMS",
        SET_ACTIVE_PAGE_ACTION_BUTTONS: "SET_ACTIVE_PAGE_ACTION_BUTTONS",
        SET_ACTIVE_PAGE_ELEMENTS: "SET_ACTIVE_PAGE_ELEMENTS",
        RESET_ACTIVE_PAGE_ELEMENTS: "RESET_ACTIVE_PAGE_ELEMENTS",
        SET_TABLE_CACHE: "SET_TABLE_CACHE",
        SET_TAB_HAS_UPDATED_FORM: "SET_TAB_HAS_UPDATED_FORM",
        SET_CONFIRM_OPTIONS: "SET_CONFIRM_OPTIONS",
        REMOVE_ALL_TABS: "REMOVE_ALL_TABS"
    },
    LoanProgramIds: {
        BRIDGE: "a8804f37-5154-42dd-86ff-a8a800eca6d0",
        DEVELOPMENT: "4f226397-0eff-40d1-92b6-a63c00d06ba5",
        FIX_AND_FLIP: "09fcb6e2-c45e-4961-be52-a8a800f05b6a",
        NEW_CONSTRUCTION: "fd4c0567-8745-411e-b992-40cae5c9bd60",
        ALL_IN_ONE: "10dadf83-86e1-4f82-b86a-454824397dce",
        BRIDGE_TO_BUILD: "0047492d-f83c-480f-bfa1-aa140094771b",
    },
    LoanInsuranceCoverageType: {
        PROPERTY: "5e2b0558-ba65-4bf2-9ded-a6b80029cb95"
    },
    LoanCostAdditionalInterestBasis: {
        NO_ADDITIONAL_INTEREST: "abb18f10-94c1-46d5-baab-a64b006ff89d",
    },
    LoanBudgetStatus: {
        APPROVED: "f2c1b036-fab6-4cc7-be8c-0074846ddcc0",
        PLACEHOLDER: "f921739e-4bcd-4eb1-b3a0-ae9200c020a2"
    },
    PropertyTypeIds: {
      TOWNHOME: "2ed7546f-c9ee-486d-94dd-ee681219ffee",
      APARTMENT: "63af6af7-d139-41a5-b890-a63c00cd1087",
      CONDO: "0bf8dfcc-3bb8-445f-97ae-b4af3b26ebdf",
      OTHER: "0a738e27-78a3-4d0f-9385-a63c00cd14d7",
      MULTI_UNIT: "ac127be4-a59a-40ec-92d8-f1d15ea9559f",
      NO_STRUCTURE_LAND: "cec284dd-8fba-48d6-a0ee-a63c00cd08ec",
      SINGLE_FAMILY: "e9240848-0fce-4f21-9e2c-a371adaad0bc",
      LAND_UNDEVELOPED: "13a2fbfe-e0bd-4f1e-a56f-ad9600f0853a"
    },
    PurchaseOrRefinanceOptionIds: {
        PURCHASE: "f2820074-37f8-4485-a8a0-f3189e4147d6",
        REFINANCE_EXTERNAL: "900e6983-236d-408c-b903-ee1091022f36",
        OWN: "a978b70c-d254-48dc-a634-e909a4a9489a",
        REFINANCE_INTERNAL: "be93b28f-0992-44b7-8e2a-0eabeb947b7d"
    },
    UnitMeasurements: {
      ACRE: "cb8c9320-c2e9-41b3-b845-698e1ef078f9",
      SQFT: "bf09baeb-8f96-4b35-ab45-a67a64c3b7e9",
    },
    ZipSearchScopeOptions: {
        types: ["(regions)"],
        componentRestrictions: { country: ["us"] }
    },
    WhoWillDoConstructionBorrowerApplicationInputIds: {
        IS_GENERAL_CONTRACTOR: "4b7fac75-2b86-44c4-9a51-614e3ac0c6b2",
        HIRING_GENERAL_CONTRACTOR: "c300f4af-faad-4866-b570-6bac952e39a2"
    },
    DurationOwnedIds: {
        NEW_PURCHASE: "ae009dca-8331-4ce2-a722-8cc8f1156279",
        LESS_THAN_TWO_YEARS: "1738becb-a35d-4a7e-a7a2-93cddd85c57b",
        MORE_THAN_TWO_YEARS: "e0531d10-29d0-4619-8e32-8d502f8f5bb2"
    },
    YesNoUnknownIds: {
        YES: "11aeecd1-13cc-4236-b7f1-865734ac7465"
    },
    PayoffStrategyIds: {
        OTHER: "66b0c1d8-53fa-481b-8879-1b3346a0fdb0"
    },
    InterestCalculationMethodIds: {
        MONTHLY_PAYMENTS: "60fc9905-b347-486a-82a5-6948274dcab4",
        INTEREST_RESERVE: "af0cc887-8d1b-43c5-b02c-a0056ab80b20"
    },
    AccessLevelIds: {
        FULL_EDIT: "b5f4dd30-70a7-439b-8770-a6b60a55f891",
        VIEW_ONLY: "b15eefdc-305a-4774-9bc3-d30cca905a00",
        LIMITED: "ece51bab-0d81-412c-ab6d-6fc0e382f657"
    },
    MaritalStatusIds: {
        MARRIED: "a97b069e-aa22-49b8-ac00-7d74509a4739",
        UNMARRIED: "0b79ff69-5ee8-412d-8734-faa0caad3705"
    },
    PermitStatusIds: {
        ISSUED: "3591db95-8374-4e9a-9dc7-a64400fe12f1",
        NOT_APPLICABLE: "25a76805-2fa4-40ba-92bd-a737005b050d",
        FINAL_ENGINEERING: "c87fc9d1-8d80-4ccd-82c9-a64400fe2ae9",
        EXPIRED: "bbeb1c5d-0887-4445-8c54-a64400fe1889",
        NO_APPLICATION: "e9970c8b-8697-40f4-96e9-a64400fe04cf",
        OTHER: "6a815df1-43bf-4e04-894f-a64400fe2dbe",
        PENDING: "958566e4-4834-4646-9a87-a64400fe0c82",
        PRELIM_ENGINEERING: "0107894a-7605-44bd-a7c8-a64400fe226d",
        SUBMITTED: "25a2e69a-f729-45c2-9fd9-a7e600d041cb"
    },
    LoanVersion : {
        ORIGINAL: "original",
        CURRENT: "current"
    },
    Altype: {
        ASSET: "Asset",
        LIABILITY: "Liability"
    },
    AlClassId: {
      ASSET: "b6468698-45bf-4935-ac17-a7fa006be228",
      LIABILITY: "5584023c-7712-400d-bdd9-a7fa006bb2be"
    },
    projectInfoValidationTypes: {
      "name": "string",
      "loanProgramId": "string",
      "zip": "string",
      "requestedClosingDate": "string",
      "requestedLoanTermInMonths": "int",
      "budget": "string"
    },
    projectCostsPaidValidationTypes: {
      "gmrprojectCostId": "string",
      "amount": "dollar"
    },
    projectTermScheduleValidationTypes: {
      "monthOfFirstDraw": "int",
      "buildTimeInMonths": "int",
      "timeFrameToSellOrRefinanceInMonths": "int"
    },
    propertiesInfoValidationTypes: {
      "street": "string",
      "zip": "string",
    },
    propertiesInfoRedesignValidationTypes: {
      "street": "string",
      "zip": "string",
      "existingStructurePropertyTypeId": "string",
      "newStructurePropertyTypeId": "string",
      "parcelNumber": "string",
      "monthOfFirstDraw": "int",
      "buildTimeInMonths": "int",
      "timeFrameToSellOrRefinanceInMonths": "int",
    },
    propertyUnitsValidationTypes: {
      "unitNumber": "string",
      "asIsValue": "string",
      "afterRepairValue": "string",
    },
    propertyUnitsRedesignValidationTypes: {
      "unitNumber": "string",
      "afterRepairValue": "string",
    },
    borrowerInfoValidationTypes: {
      "name": "string",
      "zip": "string",
    },
    guarantorInfoValidationTypes: {
      "firstName": "string",
      "lastName": "string",
      "zip": "string",
    },
    guarantorCreditScoreValidationTypes: {
      "estimatedCreditScore": "int",
    },
    ALValidationTypes: {
        "altypeId": "string",
        "institution": "string",
        "value": "dollar",
    },
    ReoValidationTypes: {
        "reotypeId": "string",
        "reostatusId": "string",
        "marketValue": "dollar",
        "street": "string",
    },
    ValidationMessages: {
        REQUIRED: "field is required",
        INVALID: "is invalid",
    },
    OrganizationTypes: {
        "Bank": "6504b18a-2004-46b5-85c7-303a6afde6b2",
        "Title Company": "a1f43b01-aa94-4da4-8cb9-a66700c246a4",
        "Vendor": "f70a6e55-31e4-4a01-9756-a60a00662447",
        "Builder": "b2e840a6-abfa-453a-b699-a60a006d128d",
        "Brokerage": "93318989-bdee-47a2-862f-a6b000a05d4a",
        "Loan Company": "e1f5bff1-aa2e-4b8b-95d5-db9571abf1c2",
        "Escrow": "78c2bccc-ab60-4ced-9a48-a60a006d1f54",
        "Appraiser": "f72dedc7-870c-4fc6-9661-a97b010264d0",
        "Insurance": "b07321fd-d564-466d-961f-9ed0e41df435",
        "Other": "cf45b43c-4146-44a6-8892-953bc66a4344",
        "Subordinate Lender": "63f915e2-8f41-4554-9d78-ad5e009fd3cb",
        "Borrower": "9d8c5e53-0e9f-4e97-884b-a60a006cf333",
        "Investor": "c5cb916b-ddd7-4dd7-994b-a60a006d6ad0",
        "Inspector": "0dc4997b-aa94-4197-af8f-a60a006d3ac1",
        "Fund": "85f21170-fc79-42ce-8a5d-a60a006d2ff3"
    },
    TransactionTypes:{
        "Budget Review Fee": "46ef8f31-c9a0-4718-a2ea-adba00a212b8",
        "Project Feasibility Review Engineer Fee": "edbdf2b5-1aca-4a21-87fc-adba00a24b2f",
        "Project Feasibility Review Fee": "84e5455e-ca63-4f95-8e4f-adba00a23007"
    },
    InsuranceMetadata: {
        CoverageTypes: {
            Property: "5e2b0558-ba65-4bf2-9ded-a6b80029cb95"
        },
        PolicyTypes: {
            Liability: "74b6f6fd-1a00-49e2-80e3-71d4f1e54f20"
        }
    },
    DEFAULT_LIST_VALUES: {
        EXTENSION_TYPES: {
            BUILT_IN: "1f69f9e8-35ad-4098-a049-a64900ce6e09"
        },
        EXTENSION_DECISION: {
            APPROVED: "2cfd04fd-5c79-450b-86cb-a6ba00ba51f5"
        }
    },
    LOAN_CONDITION_STATUSES: {
        OPEN: "244fae56-1f02-4ff1-990b-acf4001b254a"
    },
    FetchMethods : {
        "GET" : "GET",
        "POST" : "POST",
        "PUT" : "PUT",
        "PATCH" : "PATCH",
        "DELETE" : "DELETE",
    },
    TableDefaultActions: {
        ADD: "add",
        EDIT: "edit",
        DELETE: "remove",
        REMOVE: "remove",
        EXPORT: "export",
        COPY: "copy",
        CLOSE: "close",
        ACTIVATE: "activate",
        DEACTIVATE: "deactivate",
        ARCHIVE: "archive",
        DOWNLOAD_SELECTED: "downloadselected",
        DOWNLOAD_BUTTON: "downloadbutton",
        SUBMIT_SELECTED: "submitselected",
        MODAL_BUTTON: "modalbutton",
    },
    FormDefaultAction : {
        SUBMIT: "submit",
        SAVE: "save",
        SAVE_CLOSE: "save-close",
        SAVE_CONTINUE: "save-continue",
        SAVE_NEW: "save-new",
        EDIT: "edit",
        DELETE: "delete",
        CLOSE: "close",
        DOWNLOAD: "download",
        REFRESH: "refresh",
    },
    Flow: {
      GMR: "gmr",
      APPLICATION: "application",
    },
    TableColumnLabelsDictionary: {
        addressOnBankAccount: "Street On Bank Account",
        specompanyName: "SPE Company Name",
        employerIdentificationNumber: "EIN/TIN",
        detailEntered: "Detail Complete",
        mlsnumber: "MLS Number",
        organizationCsv: "Organization Csv",
        organizationTypeCsv: "Organization Type CSV",
        email: "Email Address",
        officePhone: "Business Phone",
        officePhoneExtension: "Extension",
        positionInCompany: "Role in organization"
    },
    ContactsTableColumnLabelsDictionary: {
        "email": "Email Address",
        "positionInCompany": "Role in organization",
        "mailingStreet": "Street",
        "mailingZipCode": "Zip Code",
        "mailingState": "State",
        "mailingCounty": "County",
        "officePhone": "Business Phone",
        "officePhoneExtension": "Extension",
        "mlsnumber": "MLS Number",
        "detailEntered": "Detail complete",
        "organizationCsv": "Organization Csv",
        "organizationTypeCsv": "Organization Type Csv"
    },
    AddressFields: [
        "street",
        "countyName",
        "cityName",
        "stateName",
        "zip",
        "mailingStreet",
        "mailingCityName",
        "mailingStateName",
        "mailingZip",
        "mailingCountyName"
    ],
    TABLE_ROW_COLORS: {
        PINK: "#FFC0CB"
    },
    DocumentMaster: {
      PROPERTY_WORKBOOK: "4D562667-DA47-4821-A965-C67E0684E37A"
    },
    UploadOptions: {
      UPLOAD: "255baed4-ccce-4c70-8ec9-92bc5f7afb1b",
      FILL_OUT: "a68b53e6-9602-48b6-b425-3f09614537cf"
    },
    BulkEditValue: {
      MIXED: "Mixed"
    }
};

export const MsalConstants = {
    SessionLength: 6,
    CentralRedirectSubdomain: "portal", // TODO: When we launch cls change to cls
    ServiceYourLoanSplit: ".serviceyourloan"
};

export const HolidayConstants = {
    NewYearsDay: "1/1",
    IndependenceDay: "7/4",
    ChristmasDay: "12/25",
    MartinLutherKingsDay: "1/3/1",
    PresidentsDay: "2/3/1",
    LaborDay: "9/1/1",
    Thanksgiving: "11/4/4",
    DayAfterThanksgiving: "11/4/5",
    MemorialDay: ["5/0/1", "5/1/1"],
};

export const FileType = {
  JPEG: "image/jpeg",
  PNG: "image/png",
  EXCEL_BASIC: "application/vnd.ms-excel",
  EXCEL_XLSX: "application/vnd.openxmlformats-officedocument"
};

export const ErrorMessages = {
    Address: "Please enter a street address."
};

export const Personas = {
    SYSTEM_ADMIN: "System Admin",
    SALES_ADMIN: "Sales Admin",
    BROKER_ADMIN: "Broker Admin",
    LOAN_OFFICER: "Loan Officer",
    BRM: "Business Relationship Manager",
    BROKER: "Broker",
    WL_GUARANTOR: "Wholesale Guarantor",
    NWL_GUARANTOR: "Retail Guarantor",
    SALES_ASSISTANT: "Sales Assistant",
    UNKNOWN: "Unknown"
};

export const Roles = {
    SYSTEM_ADMIN: "SystemAdmin",
    NATIONAL_SALES_MANAGER: "NationalSalesManager",
    SENIOR_SALES_EXECUTIVE: "SeniorSalesExecutive",
    SALES_MANAGER: "SalesManager",
    SALES_ADMIN: "SalesAdmin",
    BROKER_ADMIN: "BrokerAdmin",
    BORROWER: "Borrower",
    BROKER: "Broker",
    BUILDER: "Builder",
    GUARANTOR: "Guarantor",
    LOAN_OFFICER: "LoanOfficer",
    OTHER_INTERNAL_USER: "OtherInternalUser",
    BRM: "BusinessRelationsManager",
    SALES_ASSISTANT: "SalesAssistant"
};

export const Permissions = {
    Brands: {
        BUILDERS_CAPITAL: "builders capital",
        CUSTOM: "custom",
        DEFAULT: "default"
    }
};

export const Environments = {
    LOCAL: "LOCAL",
    DEVELOPMENT: "DEV",
    STAGING: "UAT",
    PREPROD: "PREPROD",
    PRODUCTION: "PRODUCTION"
};

export const Sites = {
    SylSubdomains: {
        BUILDERS_CAPITAL: "builderscapital",
        CONSTRUCTION_LOAN_SERVICES: "cls"
    },
    Hosts: {
        MY: "my",
        MY_BUILDERS_CAPITAL: ".builders-capital",
        BUILDERS_CAPITAL_SYL: "builderscapital.serviceyourloan",
        SYL: ".serviceyourloan",
        CLS_SYL: "portal.serviceyourloan" // TODO: Replace with cls when cls is launched
    }
};

export const GameChangerSources = {
    // DEVELOPMENT: "https://gc-dev.builders-capital.com", 
    DEVELOPMENT: "https://devtqm.bimquote.com/external/access", // TODO: Change back after SSL issue is fixed
    STAGING: "https://devtqm.bimquote.com/external/access",
    PRODUCTION: "https://bimquote.com/external/access",
    SYL_DEVELOPMENT: "https://devtqm.bimquote.com/external/access",
    SYL_STAGING: "https://devtqm.bimquote.com/external/access",
    SYL_PRODUCTION: "https://bimquote.com/external/access"
};

export const UserFeatureFlags = [
  {
    name: "IS_RETAIL_PHASE_2",
    description: "This is used to turn on retail phase 2 features."
  }
];

export const ErrorLevels = {
    ERROR: "Error",
    USER_ERROR: "UserError",
    WARNING: "Warning",
    INFO: "Info"
};

export const YesNoBooleanRadios = [{ name: "Yes", value: true }, { name: "No", value: false }];
export const YesNoDropdownOptions = [
  { key: "Yes", value: "Yes", text: "Yes" },
  { key: "No", value: "No", text: "No" },
];

export const unitDropdownOptions = [
  { key: "acre", value: "acre", text: "acre" },
  { key: "sqft", value: "sqft", text: "sqft" },
];

export const LmsAllocationMethodOptions = [
  {
    key: "dailyAmortized",
    text: "Daily Amortized",
    value: "Daily Amortized",
  },
  {
    key: "dollarAmount",
    text: "Dollar Amount",
    value: "Dollar Amount",
  },
  {
    key: "percentageValue",
    text: "% Value",
    value: "% Value",
  }
];

export const LmsResidualHandlingOptions = [
  {
    key: "addToQueue",
    text: "Add to Queue",
    value: "Add to Queue",
  },
  {
    key: "processSweep",
    text: "Process Sweep",
    value: "Process Sweep",
  },
  {
    key: "writeOff",
    text: "Write Off",
    value: "Write Off",
  },
  {
    key: "refund",
    text: "Refund",
    value: "Refund",
  }
];

export const LmsSaleTypeOptions = [
  {
    key: "saleToPurchasingCompnay",
    text: "Sale to purchasing company",
    value: "Sale to purchasing company",
  },
  {
    key: "transferFundToFund",
    text: "Transfer fund to fund",
    value: "Transfer fund to fund",
  }
];

export const LmsTransactionSplitOptions = [
  {
    key: "split",
    text: "Split",
    value: "Split",
  },
  {
    key: "apiece",
    text: "A Piece",
    value: "A Piece",
  },
  {
    key: "bpiece",
    text: "B Piece",
    value: "B Piece",
  },
];

export const LmsServiceFeeMethod = {
  BASED_ON_LOAN_AMOUNT: "65db0ac5-1a18-460b-b64d-a99d0056ea9a",
  BASED_ON_LOAN_OUTSTANDING_AMOUNT: "481b9699-d74d-43a1-bc15-a99d0057294f",
  FIXED_FEE: "5baf2ac3-716c-4600-b03b-a99d0056d735"
};

export const LmsPurchasingCompanyMetadataList = [
  {
		"id": "212f28c6-e94b-4fd4-b188-a9c30092a76b",
		"name": "1Sharpe",
		"display": "1Sharpe"
	},
	{
		"id": "75e908a9-57fd-42c4-8eb1-0c72910717ed",
		"name": "BIMQuote",
		"display": "BIMQuote"
	},
	{
		"id": "1515ff69-e2f8-4b65-b68b-aeec00935c53",
		"name": "Builders Capital Loan Acquisition Trust 2022-RTL1",
		"display": "Builders Capital Loan Acquisition Trust 2022-RTL1"
	},
	{
		"id": "55fe29ce-e9cc-4772-9eac-ac3e007b7cc1",
		"name": "Global 2020 Facility",
		"display": "Global 2020 Facility"
	},
	{
		"id": "f4c91cf8-a519-40b3-b652-adcb0084962e",
		"name": "Global 2021 Facility",
		"display": "Global 2021 Facility"
	},
	{
		"id": "c6f2ed02-df4f-4ae4-8e1e-adba01137b8b",
		"name": "Saluda Grade Asset Funding LLC",
		"display": "Saluda Grade Asset Funding LLC"
	},
	{
		"id": "336384c2-c0e3-4971-8c5f-ade100d2a77d",
		"name": "SGAMT - SGAF",
		"display": "SGAMT - SGAF"
	},
	{
		"id": "9fbc7998-5b53-4711-91c4-4be612b5d150",
		"name": "SGAMT-BC2",
		"display": "SGAMT-BC2"
	},
	{
		"id": "4b54c4ff-b2bf-460c-909f-acf600b23c7a",
		"name": "SGAMT-BCS1",
		"display": "SGAMT-BCS1"
	},
	{
		"id": "f10a2f03-9ef4-4cc1-b843-ae0700debc1c",
		"name": "SGAMT-MF1",
		"display": "SGAMT-MF1"
	},
	{
		"id": "7a482a43-802c-40b8-8c34-ae0700df1d84",
		"name": "SGAMT-RTL1",
		"display": "SGAMT-RTL1"
	},
	{
		"id": "f6d92312-4c1d-4863-9759-ada500ef31c4",
		"name": "SGAMT-WL1",
		"display": "SGAMT-WL1"
	}
];

export const LmsBuildersCapitalPercentagesMetadataList = [
  {
    "id":"fb561aef-624d-4af9-bd2c-a99c007919de",
    "name":"0.00",
    "display":"0.00"
  },
  {
    "id":"e676e4bc-7bba-4f61-aa82-ae010123075a",
    "name":"2.00",
    "display":"2.00"
  },
  {
    "id":"3d794120-936a-4dba-965a-ac9900e482ea",
    "name":"5.00",
    "display":"5.00"
  },
  {
    "id":"02b5b6fc-76f3-4750-a39a-a9a80052e093",
    "name":"10.00",
    "display":"10.00"
  },
  {
    "id":"e81ac322-2d5f-435f-b54d-a9c300cf381e",
    "name":"15.00",
    "display":"15.00"
  },
  {
    "id":"c40a3fe5-d16b-4112-8af5-a9c300cf48e4",
    "name":"20.00",
    "display":"20.00"
  },
  {
    "id":"742239fb-2a79-474f-be86-a9c300cf4ce9",
    "name":"25.00",
    "display":"25.00"
  },
  {
    "id":"a430fade-a0d0-46b4-ae78-a9c300cf5099",
    "name":"30.00",
    "display":"30.00"
  },
  {
    "id":"375e6d8b-344a-44ad-a61a-a9c300cf54eb",
    "name":"35.00",
    "display":"35.00"
  },
  {
    "id":"38a70d75-8ee1-4772-a534-a9c300cf5868",
    "name":"40.00",
    "display":"40.00"
  },
  {
    "id":"1d635067-4e10-405c-9a16-a9c300cf5be3",
    "name":"45.00",
    "display":"45.00"
  },
  {
    "id":"dbbcb6d9-497b-44c1-b237-a9c300cf5f28",
    "name":"50.00",
    "display":"50.00"
  },
  {
    "id":"f1df690e-d691-4b65-abb6-a9c300cf6237",
    "name":"55.00",
    "display":"55.00"
  },
  {
    "id":"dff5c2f1-29e0-4007-9184-a9c300cf65b5",
    "name":"60.00",
    "display":"60.00"
  },
  {
    "id":"ff7155f4-3a44-48bb-83fe-a9c300cf68dd",
    "name":"65.00",
    "display":"65.00"
  },
  {
    "id":"2a271b55-d6be-4c99-9991-a9c300cf6cb4",
    "name":"70.00",
    "display":"70.00"
  },
  {
    "id":"828fc28d-9f2d-4e5e-b376-a9c300cf7056",
    "name":"75.00",
    "display":"75.00"
  },
  {
    "id":"4fa4020b-e901-48ca-be78-a9c300cf7422",
    "name":"80.00",
    "display":"80.00"
  },
  {
    "id":"175010b2-8d0c-4c15-9eca-a9c300cf7770",
    "name":"85.00",
    "display":"85.00"
  },
  {
    "id":"9d3fa33e-c40b-4309-8759-a9c300cf7ad1",
    "name":"90.00",
    "display":"90.00"
  },
  {
    "id":"0449cad7-5390-4e44-a855-a9c300cf7ee3",
    "name":"95.00",
    "display":"95.00"
  },
  {
    "id":"2cf0c5e4-800d-40a2-8ca6-a9c300cf8554",
    "name":"100.00",
    "display":"100.00"
  }
];

export const LmsAccountingLoanTransactionsTransactionSplitOptions = [
    {
      key: "Split",
      text: "Split",
      value: "Split",
    },
    {
      key: "APiece",
      text: "A Piece",
      value: "APiece",
    },
    {
      key: "BPiece",
      text: "B Piece",
      value: "BPiece",
    },
];

export const LmsAccountingResidualHandling = [
  {
    key: "Add to Queue",
    text: "Add to Queue",
    value: "Add to Queue",
  },
  {
    key: "Process Sweep",
    text: "Process Sweep",
    value: "Process Sweep",
  },
  {
    key: "Write Off",
    text: "Write Off",
    value: "Write Off",
  },
  {
    key: "Refund",
    text: "Refund",
    value: "Refund",
  },
  {
    key: "Refer to Collections",
    text: "Refer to Collections",
    value: "Refer to Collections",
  },
];

export const LmsVotingFeeBasedOffOptions = [
  {
    key: "Original Committed Loan Amount",
    text: "Original Committed Loan Amount",
    value: "Original Committed Loan Amount",
  },
  {
    key: "Current Balance",
    text: "Current Balance",
    value: "Current Balance",
  },
  {
    key: "Loan Amount Change",
    text: "Loan Amount Change",
    value: "Loan Amount Change",
  },
  {
    key: "Flat Fee",
    text: "Flat Fee",
    value: "Flat Fee",
  },
  {
    key: "New Committed Loan Amount",
    text: "New Committed Loan Amount",
    value: "New Committed Loan Amount",
  },
];

export const DrawsPaymentMethodOptions = [
  {
    key: "ACH",
    text: "ACH",
    value: "ACH",
  },
  {
    key: "Check",
    text: "Check",
    value: "Check",
  }
];

export const LmsVotingFixedRateChangeOptions = [
  {
    key: "Fixed Rate Change",
    text: "Fixed Rate Change",
    value: "Fixed Rate Change",
  },
  {
    key: "Variable Index Rate Change",
    text: "Variable Index Rate Change",
    value: "Variable Index Rate Change",
  },
];

export const LmsDocuSignSenderReceiverOptions = [
  {
    key: "Sender",
    text: "Sender",
    value: "Sender",
  },
  {
    key: "Receiver",
    text: "Receiver",
    value: "Receiver",
  },
];

export const LmsRateTypeOptions = [
    {
        key: "Fixed Term Rate",
        text: "Fixed Term Rate",
        value: "Fixed Term Rate"
    },
    {
        key: "Fixed + Adj Rate",
        text: "Fixed + Adj Rate",
        value: "Fixed + Adj Rate"
    },
    {
        key: "Adj Rate",
        text: "Adj Rate",
        value: "Adj Rate"
    }
];

export const LmsConversionTypeOptions = [
    {
        key: "Dev To Lot",
        text: "Dev To Lot",
        value: "Dev To Lot"
    },
    {
        key: "Dev To Vertical",
        text: "Dev To Vertical",
        value: "Dev To Vertical"
    },
    {
        key: "Lot To Vertical",
        text: "Lot To Vertical",
        value: "Lot To Vertical"
    }
];

export const LmsTimeDropdownOptions = [
  {
    key: "T00:00:00",
    text: "12:00 AM",
    value: "T00:00:00"
  },
  {
    key: "T00:30:00",
    text: "12:30 AM",
    value: "T00:30:00"
  },
  {
    key: "T01:00:00",
    text: "1:00 AM",
    value: "T01:00:00"
  },
  {
    key: "T01:30:00",
    text: "1:30 AM",
    value: "T01:30:00"
  },
  {
    key: "T02:00:00",
    text: "2:00 AM",
    value: "T02:00:00"
  },
  {
    key: "T02:30:00",
    text: "2:30 AM",
    value: "T02:30:00"
  },
  {
    key: "T03:00:00",
    text: "3:00 AM",
    value: "T03:00:00"
  },
  {
    key: "T03:30:00",
    text: "3:30 AM",
    value: "T03:30:00"
  },
  {
    key: "T04:00:00",
    text: "4:00 AM",
    value: "T04:00:00"
  },
  {
    key: "T04:30:00",
    text: "4:30 AM",
    value: "T04:30:00"
  },
  {
    key: "T05:00:00",
    text: "5:00 AM",
    value: "T05:00:00"
  },
  {
    key: "T05:30:00",
    text: "5:30 AM",
    value: "T05:30:00"
  },
  {
    key: "T06:00:00",
    text: "6:00 AM",
    value: "T06:00:00"
  },
  {
    key: "T06:30:00",
    text: "6:30 AM",
    value: "T06:30:00"
  },
  {
    key: "T07:00:00",
    text: "7:00 AM",
    value: "T07:00:00"
  },
  {
    key: "T07:30:00",
    text: "7:30 AM",
    value: "T07:30:00"
  },
  {
    key: "T08:00:00",
    text: "8:00 AM",
    value: "T08:00:00"
  },
  {
    key: "T08:30:00",
    text: "8:30 AM",
    value: "T08:30:00"
  },
  {
    key: "T09:00:00",
    text: "9:00 AM",
    value: "T09:00:00"
  },
  {
    key: "T09:30:00",
    text: "9:30 AM",
    value: "T09:30:00"
  },
  {
    key: "T10:00:00",
    text: "10:00 AM",
    value: "T10:00:00"
  },
  {
    key: "T10:30:00",
    text: "10:30 AM",
    value: "T10:30:00"
  },
  {
    key: "T11:00:00",
    text: "11:00 AM",
    value: "T11:00:00"
  },
  {
    key: "T11:30:00",
    text: "11:30 AM",
    value: "T11:30:00"
  },
  {
    key: "T12:00:00",
    text: "12:00 PM",
    value: "T12:00:00"
  },
  {
    key: "T12:30:00",
    text: "12:30 PM",
    value: "T12:30:00"
  },
  {
    key: "T13:00:00",
    text: "1:00 PM",
    value: "T13:00:00"
  },
  {
    key: "T13:30:00",
    text: "1:30 PM",
    value: "T13:30:00"
  },
  {
    key: "T14:00:00",
    text: "2:00 PM",
    value: "T14:00:00"
  },
  {
    key: "T14:30:00",
    text: "2:30 PM",
    value: "T14:30:00"
  },
  {
    key: "T15:00:00",
    text: "3:00 PM",
    value: "T15:00:00"
  },
  {
    key: "T15:30:00",
    text: "3:30 PM",
    value: "T15:30:00"
  },
  {
    key: "T16:00:00",
    text: "4:00 PM",
    value: "T16:00:00"
  },
  {
    key: "T16:30:00",
    text: "4:30 PM",
    value: "T16:30:00"
  },
  {
    key: "T17:00:00",
    text: "5:00 PM",
    value: "T17:00:00"
  },
  {
    key: "T17:30:00",
    text: "5:30 PM",
    value: "T17:30:00"
  },
  {
    key: "T18:00:00",
    text: "6:00 PM",
    value: "T18:00:00"
  },
  {
    key: "T18:30:00",
    text: "6:30 PM",
    value: "T18:30:00"
  },
  {
    key: "T19:00:00",
    text: "7:00 PM",
    value: "T19:00:00"
  },
  {
    key: "T19:30:00",
    text: "7:30 PM",
    value: "T19:30:00"
  },
  {
    key: "T20:00:00",
    text: "8:00 PM",
    value: "T20:00:00"
  },
  {
    key: "T20:30:00",
    text: "8:30 PM",
    value: "T20:30:00"
  },
  {
    key: "T21:00:00",
    text: "9:00 PM",
    value: "T21:00:00"
  },
  {
    key: "T21:30:00",
    text: "9:30 PM",
    value: "T21:30:00"
  },
  {
    key: "T22:00:00",
    text: "10:00 PM",
    value: "T22:00:00"
  },
  {
    key: "T22:30:00",
    text: "10:30 PM",
    value: "T22:30:00"
  },
  {
    key: "T23:00:00",
    text: "11:00 PM",
    value: "T23:00:00"
  },
  {
    key: "T23:30:00",
    text: "11:30 PM",
    value: "T23:30:00"
  },
];
 
export const LmsPortalOptions = [
  {
    key: "Borrower Portal",
    text: "Borrower Portal",
    value: "Borrower Portal"
  },
  {
    key: "LO Portal",
    text: "LO Portal",
    value: "LO Portal"
  },
  {
    key: "LP Portal",
    text: "LP Portal",
    value: "LP Portal"
  },
  {
    key: "Vendor Portal",
    text: "Vendor Portal",
    value: "Vendor Portal"
  },
  {
    key: "LMS",
    text: "LMS",
    value: "LMS"
  }
];

export const WipPaidToOptions = [
  {
    key: "Borrower",
    text: "Borrower",
    value: "Borrower"
  },
  {
    key: "Vendor",
    text: "Vendor",
    value: "Vendor"
  },
  {
    key: "N/A",
    text: "N/A",
    value: "N/A"
  }
];

export const ErrorPages = {
  NO_MATERIAL_ON_SITE: "No Materials on Site",
  SCREEN_SIZE_NOT_SUPPORTED: "Screen Size Not Supported"
};

export const TableTypesDictionary = {
    "{0:c2}": "currency",
    "{0:C2}": "currency",
    "{0:p2}": "percentage",
    "{0:P2}": "percentage",
};